module.exports = __webpack_public_path__ + "static/media/sell_finish_service_rent_1.1be9b093.jpg";